import styled from "styled-components";

export const CheckboxWrapper = styled.div`
  padding-bottom: 1em;
  width: 70%;
  text-align: left;
`;

export const Checkbox = styled.input`
  display: inline-block;
`;
